(function() {
   angular.module('e360')
      .factory('countryService', countryService);

   countryService.$inject = ['$q', 'apiHelper'];
   function countryService($q, apiHelper) {
      var cache;

      return {
         list: listCountries
      };

      function listCountries() {
         if (cache) {
            return $q.resolve(cache);
         }

         return apiHelper.get('countries').then(function (data) {
            return (cache = data);
         });
      }
   }
})();
